/* eslint-disable @typescript-eslint/naming-convention */
import { IFromEstimatedDeliveryMapping } from '../IDataMappings';
import { IEstimatedDeliveryResponse } from '../IApiResponses';
import cartItemsMapper from './transaction/cartItemsMapper';
import orderSummaryMapper from './transaction/orderSummaryMapper';
import deliveryOptionsMapper from './transaction/deliveryOptionsMapper';

const estimatedDeliveryMapper = {
  response(resp: IEstimatedDeliveryResponse): IFromEstimatedDeliveryMapping {
    const {
      cart_items: transCartItems,
      order_summary, 
      v2_delivery_options,
    } = resp;
    const cartItems = cartItemsMapper.response({
      cartItems: transCartItems,
      transactionOrder: resp.trans_order,
    });

    const orderSummary = orderSummaryMapper.response(order_summary);
    const deliveryOptions = deliveryOptionsMapper.response(v2_delivery_options || []);

    return {
      cartItems,
      deliveryOptions,
      orderSummary,
    };
  },
};

export default estimatedDeliveryMapper;
